import { css } from '@emotion/css';

export const dropContainerStyles = css`
  /* box-shadow: inset 0 0 0 0.2rem var(--interactive-primary); */
  outline: 0.2rem solid var(--interactive-primary);
  outline-offset: -0.2rem;
`;
